import React from 'react';
import PropTypes from 'prop-types';
import { shortenDate } from '../../helpers/formatter';

/**
 * Cell with responsive display of DATE
 * Display date as DMMYYY on XN and N and as DD - DD MMMM YYYY on higher breakpoints
 *
 * @param {{}} props
 * @constructor
 */
const ResponsiveCell = props => (
    <span>
        <span className="hidden-md-up">
            {shortenDate(props.rowData[props.columnName])}
        </span>
        <span className="hidden-sm-down">
            {props.rowData[props.columnName]}
        </span>
    </span>
);

ResponsiveCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default ResponsiveCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/ResponsiveDateCell.js